import React from "react";

import * as Yup from "yup";
import { Field, Form, Formik } from "formik";
import { Input } from "../../../../../../_metronic/_partials/controls";

const NoticeEditSchema = Yup.object().shape({
    name: Yup.string(),
    description: Yup.string(),
});

const NoticeEditForm = ({ notice, btnRef, saveNotice }) => {
    return (
        <>
            <Formik
                initialValues={notice}
                onSubmit={(values) => saveNotice(values)}
                validationSchema={NoticeEditSchema}
                enableReinitialize={true}
            >
                {({ handleSubmit, setFieldValue, values }) => (
                    <>
                        {values && (
                            <Form className={"form form-label-right"}>
                                <div className={"form-group row"}>
                                    <div className={"col-lg-4"}>
                                        <Field
                                            name={"name"}
                                            component={Input}
                                            label={"عنوان اطلاعیه"}
                                            type={"text"}
                                        />
                                    </div>

                                    <div className={"col-lg-8"}>
                                        <Field
                                            name={"description"}
                                            component={Input}
                                            label={"توضیحات"}
                                            type={"text"}
                                            useQuill={true}
                                        />
                                    </div>
                                </div>

                                <button
                                    type={"submit"}
                                    style={{ display: "none" }}
                                    ref={btnRef}
                                    onSubmit={() => handleSubmit()}
                                />
                            </Form>
                        )}
                    </>
                )}
            </Formik>
        </>
    );
};

export default NoticeEditForm;
